import axios from 'axios';
import {backendHost} from '../../config';

export const getMediaById = (params) => {
    return axios.get(`${backendHost}/api/partners/admin/media/${params.id}`);
};